import { Hooks } from "../../types/Hooks";

(() => {
  const SrOnlyValueToggles = Array.from(document.querySelectorAll(Hooks.SrOnly)) as HTMLElement[];
  for(const toggleElement of SrOnlyValueToggles) {
      toggleElement?.parentElement?.addEventListener("click", (e: Event) => {
        const newToggleValue = toggleElement.dataset.toggleValue;
        const oldToggleValue = toggleElement.textContent;

        if (!newToggleValue || !oldToggleValue) {
          return;
        }

        toggleElement.dataset.toggleValue = oldToggleValue
        toggleElement.textContent = newToggleValue;
      });
  }
})();
